module.exports = "https://web-assets-production.autolist.com/_next/static/images/minivan-fca09dc53b023ee63955aaf2375e197c.jpg";